<template>
	<div id="dynvibeSearchFiltersActive" class="col-lg-2" v-if="displayincoming == true">
		<div class="dynvibeFilters">
			<div>
				<label class="labelCheckbox" style="cursor: not-allowed"
					>Semantic filter
					<input
						type="checkbox"
						v-model="filters.semanticfilter"
						@click="filters.semanticfilter = !semanticfilter.semanticfilter"
						disabled
					/>
					<span class="checkmark"></span>
				</label>

				<label class="labelCheckbox" style="cursor: not-allowed"
					>In affinity with trends
					<input
						type="checkbox"
						v-model="filters.affinitytrends"
						@click="filters.affinitytrends = !filters.affinitytrends"
						disabled
					/>
					<span class="checkmark"></span>
				</label>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		displayincoming: {
			type: Boolean,
			default: false,
		},
	},
	name: "semanticfilter",
	data() {
		return {
			filters: {
				semanticfilter: false,
				affinitytrends: false,
			},
		};
	},
	methods: {
		loadComponent() {
			//this.getData("trendFilter");
		},
		treatResponse() {},
	},
	watch: {
		filters: function () {
			this.$emit("semanticfilters", this.filters);
		},
	},
};
</script>

<style scoped>
.labelCheckbox {
	display: block;
	position: relative;
	padding-left: 25px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 300;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.labelCheckbox input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 15px;
	width: 15px;
	background-color: #ddd;
}

/* On mouse-over, add a grey background color */
.labelCheckbox:hover input ~ .checkmark {
	background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.labelCheckbox input:checked ~ .checkmark {
	/*background-color: #2196f3;*/
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
	content: "\e923";
	position: absolute;
	display: none;
}

/* Show the checkmark when checked */
.labelCheckbox input:checked ~ .checkmark:after {
	display: block;
}

/* Style the checkmark/indicator */
.labelCheckbox .checkmark:after {
	content: "\e923";
	position: relative;
	top: -2px;
	font-family: "Montserrat";
	font-size: 11px;
	line-height: 20px;
	color: #46b132;
}
</style>
